export default __webpack_public_path__ + "static/media/46.d20eca73.png";